export const radii = {
  px: '3px',
  xs: '4px',
  sm: '6px',
  md: '8px',
  lg: '14px',
  xl: '20px',
  full: '99999px',
} as const;
